import { useMutation } from "@tanstack/react-query";
import { fetchClient } from "../../API/fetchClient";
import type { VeilleEvenementiellleParams, VeilleEvenementiellleResponse } from "./types";

async function runVeilleEvenementielle(
  params: VeilleEvenementiellleParams
): Promise<VeilleEvenementiellleResponse> {
  const response = await fetchClient<VeilleEvenementiellleResponse>(
    "/core/media-scout/run_evenementielle/",
    { method: "POST", body: params }
  );

  if (response.error || !response.data) {
    const detail =
      response.error?.detail ??
      response.error?.message ??
      "Erreur lors de l'exécution de la veille événementielle.";
    throw new Error(detail);
  }

  if (response.data.status === "error") {
    throw new Error("Erreur lors de l'exécution de la veille événementielle.");
  }

  return response.data;
}

export function useRunVeilleEvenementielle() {
  return useMutation<VeilleEvenementiellleResponse, Error, VeilleEvenementiellleParams>({
    mutationFn: runVeilleEvenementielle,
  });
}
